import { useCallback, useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ChevronDownIcon, PuntoVentaIcon } from '../../../../assets/svg/iconos';

import useClickOutside from '../../../../hooks/useClickOutside';

export const SelectServicios = ({objCategoria, dataChange}) => {

    const { servicios } = useSelector(state => state.servicios);

    const [selectText, setSelectText] = useState('');

    const popover = useRef();
    const [isOpen, toggle] = useState(false);

    useEffect(() => {
        if( objCategoria?.servicios?.length > 0 ){
            let seleccionadas = 0;
            servicios.forEach( servicio => {
                if( objCategoria.servicios.includes( servicio._id ) && !servicio.deleted ){
                    seleccionadas++;
                }
            });
            if( seleccionadas === 0 ){
                setSelectText( 'Ninguno' );
            } else if( seleccionadas === servicios.length ){
                setSelectText( 'Todos' );
            } else {
                setSelectText( 'Algunos' );
            }
        } else {
            setSelectText( 'Ninguno' );
        }
    }, [objCategoria, servicios]);
    

    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    const clickSelect = () => {
        toggle( !isOpen );
    }

    const clickServicio = ( idServicio ) => {
        let newServicios = [];
            if( objCategoria.servicios.includes( idServicio ) ){
                newServicios = objCategoria.servicios.filter( serv => {
                    return serv !== idServicio;
                });
                // console.log( newServicios );
            } else {
                newServicios = [
                    ...objCategoria.servicios,
                    idServicio
                ]
            }
            dataChange('servicios', newServicios );
    }

    return (
        <div 
            className='ylm-categoria-select categoria-servicios'
        >
            <div 
                className='select-main'
                onClick={ clickSelect }
            >
                <div className='var-icon'>
                    <PuntoVentaIcon />
                </div>
                <div className='var-data'>
                    <h4>Servicios que aplican</h4>
                    <p>{ selectText }</p>
                </div>
                <div 
                    className={`btn-chevron ${isOpen ? 'active' : ''}`}
                >
                    <ChevronDownIcon />
                </div>
            </div>
            {
                isOpen &&
                <ul 
                    className={`select-options opt-servicios std-ul big`}
                    ref={popover}
                >
                    {
                        servicios.map( servicio => (
                            !servicio.deleted &&
                            <li
                                className={`std-li ${objCategoria?.servicios.includes( servicio._id ) ? 'active' : ''}`}
                                key={ servicio._id }
                                onClick={ () => clickServicio( servicio._id )}
                            >
                                <div  
                                    className={`checkbox-bg`}
                                >
                                    {
                                        objCategoria?.servicios.includes( servicio._id ) &&
                                        <span 
                                            className='checkbox-item'
                                        ></span>
                                    }
                                </div>
                                <p>{ servicio.nombre }</p>
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    )
}
